import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CommercialCertificateHint from './CommercialCertificateHint';
import { Size } from '../../../../Enums/Size.enum';

const CommercialCertificateHintModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			{...props}
			title='component.certificates.commerce.step1.hintTitle'
			size={Size.LG}>
			<CommercialCertificateHint />
		</BaseModal>
	);
};

export default CommercialCertificateHintModal;
